// extracted by css-extract-rspack-plugin
export default {"main":"k_jha","resizing":"XYuLT"};